import React, { useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const InteriorDesignerTemplateWidget = ({ selectedLayout,isTemplateId,widgetId,numberCounterTabData }) => {
    const {
        is_website_frontend,
    } = numberCounterTabData || {};

    // Call Css
    useEffect(() => {
        // Remove other module CSS
        const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
        oldLinks.forEach(link => link.remove());

        // Load CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${process.env.PUBLIC_URL}/photo-gallery/temp-css/PhotoGallery.css`;
        if (widgetId) {
            link.setAttribute("photo-gallery-data-dynamic-css", "photo-gallery");
        } else {
            link.setAttribute("data-dynamic-css", "photo-gallery");
        }
        document.head.appendChild(link);

        // Clean up on unmount
        return () => {
            const thisLink = document.querySelector('link[data-dynamic-css="photo-gallery"]');
            if (thisLink) thisLink.remove();
        };
    }, [widgetId]);

    const images = [
        {
            image: `${process.env.PUBLIC_URL}/photo-gallery/templates/interior-designer/image.png`,
            image_alt: 'image',
          },
          {
            image: `${process.env.PUBLIC_URL}/photo-gallery/templates/interior-designer/image-1.png`,
            image_alt: 'image-1',
          },
          {
            image: `${process.env.PUBLIC_URL}/photo-gallery/templates/interior-designer/image-2.png`,
            image_alt: 'image-2',
          },
          {
            image: `${process.env.PUBLIC_URL}/photo-gallery/templates/interior-designer/image-3.png`,
            image_alt: 'image-3',
          },
    ];

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: false,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                },
            },
        ],
    };

    return (
        <>
            <div className={`upgadeify photo_gallery interior-designer-temp ${is_website_frontend}`}>
                <div className='interior-designer-temp_inner'>
                    <div className='interior-designer-temp__content'>
                        <Slider {...sliderSettings}>
                            {images.map((image_data, index) => (
                                <div className='interior-designer-temp_gallery'>
                                    <img className='main-image' src={image_data.image} alt={image_data.image_alt} />
                                    <div className='photo_shoot_content'>
                                        <h3>{image_data.title}</h3>
                                        <p className='image-description'>{image_data.location}</p>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </>
    );
};

export default InteriorDesignerTemplateWidget;
